import React, { useState, useEffect } from "react";
import styles from "./Integrations.module.css";
import { Box } from "@mui/material";
import RecruitCrmModal from "./RecruitCrmModal";
import AtzCrmModal from "./AtzCrmModal";
import LoxoModal from "./LoxoModal";
import domain from "../../Services/DomainService";

export default function Integrations() {
  const [modalOpen, setModalOpen] = useState(false);
  const [status, setStatus] = useState(null); // null | 'success' | 'error'

  const [jobAdderStatus, setJobAdderStatus] = useState(null); // null | 'success' | 'error'
  const [jobAdderConnecting, setJobAdderConnecting] = useState(false);

  const [atzModalOpen, setAtzModalOpen] = useState(false);
  const [atzCrmStatus, setAtzCrmStatus] = useState(null); // null | 'success' | 'error'

  const [hubspotCrmStatus, setHubspotCrmStatus] = useState(null); // null | 'success' | 'error'
  const [hubspotCrmConnecting, setHubspotCrmConnecting] = useState(false);

  const [zohoRecruitStatus, setZohoRecruitStatus] = useState(null); // null | 'success' | 'error'
  const [zohoRecruitConnecting, setZohoRecruitConnecting] = useState(false);

  const [loxoModalOpen, setLoxoModalOpen] = useState(false);
  const [loxoStatus, setLoxoStatus] = useState(null); // null | 'success' | 'error'

  useEffect(() => {
    const token = localStorage.getItem("token");

    fetch(domain() + "recruit-crm/status", {
      headers: { Authorization: "JWT " + token },
    })
      .then((res) => res.json())
      .then((json) => {
        console.log("[RecruitCRM status]", json);
        if (json.connected) setStatus("success");
      })
      .catch((err) => console.error("[RecruitCRM status error]", err));

    fetch(domain() + "jobadder/status", {
      headers: { Authorization: "JWT " + token },
    })
      .then((res) => res.json())
      .then((json) => {
        console.log("[JobAdder status]", json);
        if (json.connected) setJobAdderStatus("success");
      })
      .catch((err) => console.error("[JobAdder status error]", err));

    fetch(domain() + "atz-crm/status", {
      headers: { Authorization: "JWT " + token },
    })
      .then((res) => res.json())
      .then((json) => {
        console.log("[ATZ CRM status]", json);
        if (json.connected) setAtzCrmStatus("success");
      })
      .catch((err) => console.error("[ATZ CRM status error]", err));

    fetch(domain() + "hubspot-crm/status", {
      headers: { Authorization: "JWT " + token },
    })
      .then((res) => res.json())
      .then((json) => {
        console.log("[HubSpot CRM status]", json);
        if (json.connected) setHubspotCrmStatus("success");
      })
      .catch((err) => console.error("[HubSpot CRM status error]", err));

    fetch(domain() + "zoho-recruit/status", {
      headers: { Authorization: "JWT " + token },
    })
      .then((res) => res.json())
      .then((json) => {
        console.log("[Zoho Recruit status]", json);
        if (json.connected) setZohoRecruitStatus("success");
      })
      .catch((err) => console.error("[Zoho Recruit status error]", err));

    fetch(domain() + "loxo/status", {
      headers: { Authorization: "JWT " + token },
    })
      .then((res) => res.json())
      .then((json) => {
        console.log("[Loxo status]", json);
        if (json.connected) setLoxoStatus("success");
      })
      .catch((err) => console.error("[Loxo status error]", err));

    // reflect the just-completed OAuth redirect immediately, then strip the
    // query param so a refresh doesn't re-show it
    const params = new URLSearchParams(window.location.search);
    const jobAdderResult = params.get("jobadder");
    if (jobAdderResult === "success" || jobAdderResult === "error") {
      setJobAdderStatus(jobAdderResult);
      params.delete("jobadder");
    }
    const hubspotCrmResult = params.get("hubspot_crm");
    if (hubspotCrmResult === "success" || hubspotCrmResult === "error") {
      setHubspotCrmStatus(hubspotCrmResult);
      params.delete("hubspot_crm");
    }
    const zohoRecruitResult = params.get("zoho_recruit");
    if (zohoRecruitResult === "success" || zohoRecruitResult === "error") {
      setZohoRecruitStatus(zohoRecruitResult);
      params.delete("zoho_recruit");
    }
    if (jobAdderResult || hubspotCrmResult || zohoRecruitResult) {
      const newSearch = params.toString();
      window.history.replaceState(
        {},
        "",
        window.location.pathname + (newSearch ? `?${newSearch}` : "")
      );
    }
  }, []);

  const handleModalClose = (result) => {
    setModalOpen(false);
    if (result) setStatus(result);
  };

  const handleDisconnect = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(domain() + "recruit-crm/save-api-key", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "JWT " + token,
        },
        body: JSON.stringify({ api_key: "" }),
      });
      if (!res.ok) throw new Error(`Disconnect failed with status ${res.status}`);
      setStatus(null);
    } catch (err) {
      console.error("[RecruitCRM disconnect error]", err);
    }
  };

  const handleJobAdderConnect = async () => {
    const token = localStorage.getItem("token");
    setJobAdderConnecting(true);
    try {
      const res = await fetch(domain() + "auth/jobadder/authorize-url", {
        headers: { Authorization: "JWT " + token },
      });
      const json = await res.json();
      if (json.authorize_url) {
        window.location.href = json.authorize_url;
      }
    } catch (err) {
      console.error("[JobAdder connect error]", err);
      setJobAdderConnecting(false);
    }
  };

  const handleJobAdderDisconnect = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(domain() + "jobadder/disconnect", {
        method: "POST",
        headers: { Authorization: "JWT " + token },
      });
      if (!res.ok) throw new Error(`Disconnect failed with status ${res.status}`);
      setJobAdderStatus(null);
    } catch (err) {
      console.error("[JobAdder disconnect error]", err);
    }
  };

  const handleHubspotCrmConnect = async () => {
    const token = localStorage.getItem("token");
    setHubspotCrmConnecting(true);
    try {
      const res = await fetch(domain() + "auth/hubspot-crm/authorize-url", {
        headers: { Authorization: "JWT " + token },
      });
      const json = await res.json();
      if (json.authorize_url) {
        window.location.href = json.authorize_url;
      }
    } catch (err) {
      console.error("[HubSpot CRM connect error]", err);
      setHubspotCrmConnecting(false);
    }
  };

  const handleHubspotCrmDisconnect = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(domain() + "hubspot-crm/disconnect", {
        method: "POST",
        headers: { Authorization: "JWT " + token },
      });
      if (!res.ok) throw new Error(`Disconnect failed with status ${res.status}`);
      setHubspotCrmStatus(null);
    } catch (err) {
      console.error("[HubSpot CRM disconnect error]", err);
    }
  };

  const handleZohoRecruitConnect = async () => {
    const token = localStorage.getItem("token");
    setZohoRecruitConnecting(true);
    try {
      const res = await fetch(domain() + "auth/zoho-recruit/authorize-url", {
        headers: { Authorization: "JWT " + token },
      });
      const json = await res.json();
      if (json.authorize_url) {
        window.location.href = json.authorize_url;
      }
    } catch (err) {
      console.error("[Zoho Recruit connect error]", err);
      setZohoRecruitConnecting(false);
    }
  };

  const handleZohoRecruitDisconnect = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(domain() + "zoho-recruit/disconnect", {
        method: "POST",
        headers: { Authorization: "JWT " + token },
      });
      if (!res.ok) throw new Error(`Disconnect failed with status ${res.status}`);
      setZohoRecruitStatus(null);
    } catch (err) {
      console.error("[Zoho Recruit disconnect error]", err);
    }
  };

  const handleAtzModalClose = (result) => {
    setAtzModalOpen(false);
    if (result) setAtzCrmStatus(result);
  };

  const handleAtzDisconnect = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(domain() + "atz-crm/save-api-key", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "JWT " + token,
        },
        body: JSON.stringify({ api_key: "" }),
      });
      if (!res.ok) throw new Error(`Disconnect failed with status ${res.status}`);
      setAtzCrmStatus(null);
    } catch (err) {
      console.error("[ATZ CRM disconnect error]", err);
    }
  };

  const handleLoxoModalClose = (result) => {
    setLoxoModalOpen(false);
    if (result) setLoxoStatus(result);
  };

  const handleLoxoDisconnect = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(domain() + "loxo/save-api-key", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "JWT " + token,
        },
        body: JSON.stringify({ api_key: "" }),
      });
      if (!res.ok) throw new Error(`Disconnect failed with status ${res.status}`);
      setLoxoStatus(null);
    } catch (err) {
      console.error("[Loxo disconnect error]", err);
    }
  };

  return (
    <div style={{ padding: "1.5rem 2.5rem", background: "var(--color-grey-50)", minHeight: "100vh" }}>
      <Box mb="2rem">
        <h1>Integrations</h1>
        <p style={{ color: "#2563EB", margin: 0 }}>Integrate Kynzo with your go-to tools.</p>
      </Box>

      <div className={styles.grid}>
        {/* RecruitCRM */}
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <img src="/images/recruitcrm_logo.png" alt="Recruit CRM" style={{ height: "40px" }} />
            <span className={styles.cardTitle}>Recruit CRM</span>
          </div>
          <p className={styles.cardDesc}>
            Connect with RecruitCRM to auto-sync your contact into Kynzo
          </p>
          <div className={styles.cardActions}>
            {status === "success" ? (
              <button className={styles.disconnectBtn} onClick={handleDisconnect}>
                Disconnect
              </button>
            ) : (
              <>
                <button className={styles.connectBtn} onClick={() => setModalOpen(true)}>
                  Connect
                </button>
                {status === "error" && (
                  <span className={styles.statusError}>Error</span>
                )}
              </>
            )}
          </div>
        </div>

        {/* JobAdder */}
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <img src="/images/jobadder_logo.png" alt="JobAdder" style={{ height: "40px" }} />
            <span className={styles.cardTitle}>JobAdder</span>
          </div>
          <p className={styles.cardDesc}>
            Connect with JobAdder to auto-sync your contact into Kynzo
          </p>
          <div className={styles.cardActions}>
            {jobAdderStatus === "success" ? (
              <button className={styles.disconnectBtn} onClick={handleJobAdderDisconnect}>
                Disconnect
              </button>
            ) : (
              <>
                <button
                  className={styles.connectBtn}
                  onClick={handleJobAdderConnect}
                  disabled={jobAdderConnecting}
                >
                  Connect
                </button>
                {jobAdderStatus === "error" && (
                  <span className={styles.statusError}>Error</span>
                )}
              </>
            )}
          </div>
        </div>

        {/* ATZ CRM */}
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <img src="/images/atz_crm_logo.jpeg" alt="ATZ CRM" style={{ height: "40px" }} />
            <span className={styles.cardTitle}>ATZ CRM</span>
          </div>
          <p className={styles.cardDesc}>
            Connect with ATZ CRM to auto-sync your contact into Kynzo
          </p>
          <div className={styles.cardActions}>
            {atzCrmStatus === "success" ? (
              <button className={styles.disconnectBtn} onClick={handleAtzDisconnect}>
                Disconnect
              </button>
            ) : (
              <>
                <button className={styles.connectBtn} onClick={() => setAtzModalOpen(true)}>
                  Connect
                </button>
                {atzCrmStatus === "error" && (
                  <span className={styles.statusError}>Error</span>
                )}
              </>
            )}
          </div>
        </div>

        {/* Loxo */}
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <img src="/images/loxo_logo.svg" alt="Loxo" style={{ height: "40px" }} />
            <span className={styles.cardTitle}>Loxo</span>
          </div>
          <p className={styles.cardDesc}>
            Connect with Loxo to auto-sync your contact into Kynzo
          </p>
          <div className={styles.cardActions}>
            {loxoStatus === "success" ? (
              <button className={styles.disconnectBtn} onClick={handleLoxoDisconnect}>
                Disconnect
              </button>
            ) : (
              <>
                <button className={styles.connectBtn} onClick={() => setLoxoModalOpen(true)}>
                  Connect
                </button>
                {loxoStatus === "error" && (
                  <span className={styles.statusError}>Error</span>
                )}
              </>
            )}
          </div>
        </div>

        {/* HubSpot */}
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <img src="/images/hubspot_logo.png" alt="HubSpot" style={{ height: "40px" }} />
            <span className={styles.cardTitle}>HubSpot</span>
          </div>
          <p className={styles.cardDesc}>
            Connect with HubSpot to auto-sync your contact into Kynzo
          </p>
          <div className={styles.cardActions}>
            {hubspotCrmStatus === "success" ? (
              <button className={styles.disconnectBtn} onClick={handleHubspotCrmDisconnect}>
                Disconnect
              </button>
            ) : (
              <>
                <button
                  className={styles.connectBtn}
                  onClick={handleHubspotCrmConnect}
                  disabled={hubspotCrmConnecting}
                >
                  Connect
                </button>
                {hubspotCrmStatus === "error" && (
                  <span className={styles.statusError}>Error</span>
                )}
              </>
            )}
          </div>
        </div>

        {/* Zoho Recruit */}
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <img src="/images/zoho_recruit_logo.png" alt="Zoho Recruit" style={{ height: "40px" }} />
            <span className={styles.cardTitle}>Zoho Recruit</span>
          </div>
          <p className={styles.cardDesc}>
            Connect with Zoho Recruit to auto-sync your contact into Kynzo
          </p>
          <div className={styles.cardActions}>
            {zohoRecruitStatus === "success" ? (
              <button className={styles.disconnectBtn} onClick={handleZohoRecruitDisconnect}>
                Disconnect
              </button>
            ) : (
              <>
                <button
                  className={styles.connectBtn}
                  onClick={handleZohoRecruitConnect}
                  disabled={zohoRecruitConnecting}
                >
                  Connect
                </button>
                {zohoRecruitStatus === "error" && (
                  <span className={styles.statusError}>Error</span>
                )}
              </>
            )}
          </div>
        </div>

        {/* Clockwork Recruiting */}
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <img src="/images/clockwork_logo.jpeg" alt="Clockwork Recruiting" style={{ height: "40px" }} />
            <span className={styles.cardTitle}>Clockwork Recruiting</span>
            <span className={styles.comingSoonChip}>Coming soon</span>
          </div>
          <p className={styles.cardDesc}>
            Connect with Clockwork Recruiting to auto-sync your contact into Kynzo
          </p>
        </div>
      </div>

      <RecruitCrmModal open={modalOpen} onClose={handleModalClose} />
      <AtzCrmModal open={atzModalOpen} onClose={handleAtzModalClose} />
      <LoxoModal open={loxoModalOpen} onClose={handleLoxoModalClose} />
    </div>
  );
}
